import { useEffect, useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config/Constants";
import { PaginationLayout } from "./PaginationLayout";
import { generateForwardArray, getActivePages } from "./helper";

type Props = {
  currentPage: number;
  totalData: number;
  rowsPerPage: number;
  isTableDataLoading?: boolean;
  totalPages: number;
  onPageChange: (page: number) => void;
};

export const Pagination = ({
  isTableDataLoading,
  totalData,
  currentPage,
  rowsPerPage,
  totalPages,
  onPageChange,
}: Props) => {
  const [activePages, setActivePages] = useState<any>([]);
  let firstIndex = (currentPage - 1) * rowsPerPage + 1;
  let lastIndex =
    currentPage * rowsPerPage +
    (totalPages === currentPage ? (totalData % rowsPerPage) - rowsPerPage : 0);

  useEffect(() => {
    let paginationArray = generateForwardArray(1,5,totalPages)
    setActivePages(paginationArray);
  }, [totalPages]); // eslint-disable-line

  const handlePageChange = (page: number,type?:string) => {
    if (!activePages.includes(page)) {
     setActivePages(getActivePages(page,type,activePages,totalPages))
    }
    onPageChange(page);
  };

  return (
    <StyledPaginationLayout>
      <PaginationText>
        {firstIndex}-{lastIndex}
        {" of"} {totalData}
        {totalData === 1 ? " item" : " items"}
      </PaginationText>
      <PaginationLayout
        onPageChange={handlePageChange}
        isTableDataLoading={isTableDataLoading}
        totalData={totalData}
        currentPage={currentPage}
        rowsPerPage={rowsPerPage}
        totalPages={totalPages}
        activePages={activePages}
      ></PaginationLayout>
    </StyledPaginationLayout>
  );
};

const StyledPaginationLayout = styled.span`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 1.25rem;
`;

const PaginationText = styled.p`
  margin-right: 1.25rem;
  font-weight: 400;
  font-size: 12px;
  color: ${Colors.midnightExpress};
  font-family: "Poppins-Book";
  font-style: normal;
`;
